export default window.jQuery;